module.exports = __webpack_public_path__ + "static/myodetox-logo-b0a77b31d2a27c0a158ecef36cb70f6d.png";